import type { ReactNode } from 'react'
import React, { useState } from 'react'
import { TooltipStatic } from './TooltipStatic'
import type { Placement } from './types'

export type TooltipProps = {
  reference: ReactNode
  placement?: Placement
  strategy?: 'absolute' | 'fixed'
  offset?: [number, number]
  withPadding?: boolean
  fluid?: boolean
  children: ReactNode
}

export const Tooltip = ({
  reference,
  placement = 'bottom',
  strategy = 'absolute',
  offset = [0, 10],
  withPadding = true,
  fluid = false,
  children,
}: TooltipProps) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <TooltipStatic>
      <TooltipStatic.Reference
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
        onTouchStart={() => setIsOpen(true)}
        onTouchEnd={() => setIsOpen(false)}
        data-testid="Tooltip"
      >
        {reference}
        {isOpen && children && (
          <TooltipStatic.Body
            placement={placement}
            strategy={strategy}
            offset={offset}
            withPadding={withPadding}
            fluid={fluid}
          >
            {children}
          </TooltipStatic.Body>
        )}
      </TooltipStatic.Reference>
    </TooltipStatic>
  )
}
